import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IoMdAdd } from 'react-icons/io'
import { useNavigate, Route, Routes } from 'react-router-dom'
import CompanyForm from './CompanyForm'
import CompanyDetails from './CompanyDetails'
import CompanyListItem from './CompanyListItem'
import { SearchBar, Button, Spinner } from '../../../UI'
import { getAllCompanies } from '../../../store/actions'
import Container from './styles'

const Companies = () => {
  const [loading, setLoading] = useState(false)
  const [searchVal, setSearch] = useState('')
  const { CompanyData } = useSelector((s) => s)
  const [companyLists, setCompanyLists] = useState(() => CompanyData?.companyLists || [])

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getAllCompanies())
  }, [dispatch])

  useEffect(() => {
    if (CompanyData && searchVal === '') {
      setCompanyLists(CompanyData.companyLists)
    }
  }, [searchVal, CompanyData])

  const handleSearch = () => {
    setLoading(true)
    dispatch(getAllCompanies(searchVal))
      .then((response) => {
        if (response.data) {
          setCompanyLists(response)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Container>
      <Routes>
        <Route
          path=":companyId/details"
          element={<CompanyDetails />}
        />
        <Route
          path=":companyId/edit"
          element={<CompanyForm />}
        />
        <Route
          path="add"
          element={<CompanyForm />}
        />
        <Route path="/" element={
          <>
            <header>
              <div className="top--row">
                <h2>Companies</h2>
              </div>
              <div className="header--row">
                <SearchBar
                  placeholder="Search by company name"
                  handleSearch={handleSearch}
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                />
                <Button
                  className="add--btn"
                  onClick={() => navigate('/dashboard/companies/add')}
                >
                  <IoMdAdd />
                  Add Company
                </Button>
              </div>
            </header>
            <div className="admin--content__container">
              {loading ? (
                <div className="loading-container">
                  <Spinner size={'70px'} />
                  <p>
                    Searching for{' '}
                    <span className="u--color__primary">{searchVal}</span>
                  </p>
                </div>
              ) : (
                <>
                  <div className="admin--lists--container">
                    {companyLists && companyLists.data
                      ? companyLists.data.map((item) => (
                          <CompanyListItem
                            key={item.id}
                            {...item}
                            onClick={() => {
                              navigate(
                                `/dashboard/companies/${item.id}/details`,
                              )
                            }}
                          />
                        ))
                      : Array(10)
                          .fill()
                          .map((item, index) => <CompanyListItem key={index} loading={true} />)}
                  </div>

                  {companyLists && companyLists.data && companyLists.data.length === 0 && (
                    <div className="noAdminList--container">
                      <h3>No companies added</h3>
                      <p className="instruction">
                        Add companies to manage their accounts and shipments
                      </p>
                      <Button
                        onClick={() => navigate('/dashboard/companies/add')}
                      >
                        <IoMdAdd />
                        Add Company
                      </Button>
                    </div>
                  )}
                </>
              )}
            </div>
          </>
        } />
      </Routes>
    </Container>
  )
}

export default Companies
